import mod from "-!../../../../../../../../node_modules/babel-loader/lib/index.js!../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./rules.vue?vue&type=script&lang=js"; export default mod; export * from "-!../../../../../../../../node_modules/babel-loader/lib/index.js!../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./rules.vue?vue&type=script&lang=js"


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/pages/sitepages/rules/rules.vue?vue&type=script&lang=js
// module id = Jm6m
// module chunks = 0